export enum CompanyTypeBelgium {
  BV = "BV",
  NV = "NV",
  UnderIncorporation = "Under Incorporation",
}

export enum CompanyTypeUS {
  INC = "Inc.",
  LLC = "LLC",
  UnderIncorporation = "Under Incorporation",
}

export enum CompanyTypeUK {
  Limited = "Limited",
  UnderIncorporation = "Under Incorporation",
}

export enum CompanyTypeNetherlands {
  BV = "BV",
  UnderIncorporation = "Under Incorporation",
}

export enum CompanyTypeFrance {
  SARL = "SARL",
  SA = "SA",
  UnderIncorporation = "Under Incorporation",
}

export enum CompanyTypeGermany {
  GmbH = "GmbH",
  UnderIncorporation = "Under Incorporation",
}
